import { LOCAL_STORAGE_KEY } from 'helper/constant';
import AuthActionTypes from './auth.types';

export const setToken = (data) => ({
  type: AuthActionTypes.SET_TOKEN,
  payload: data,
});

export const setUserData = (data) => ({
  type: AuthActionTypes.SET_USER_DATA,
  payload: data,
});

export const removeToken = () => ({
  type: AuthActionTypes.REMOVE_TOKEN,
});

export const removeUser = () => ({
  type: AuthActionTypes.REMOVE_USER_DATA,
});

export const showToast = (data) => {
  return {
    type: AuthActionTypes.SHOW_TOAST,
    payload: data,
  };
};

export const setLocation = (data) => {
  // const switchServerLocation = window.localStorage.getItem(
  //   LOCAL_STORAGE_KEY.SWITCH_SERVER_DOMAIN
  // );

  return {
    type: AuthActionTypes.SET_LOCATION,
    // payload: switchServerLocation || data,
    payload: data,
  };
};

export const setTenant = (data) => {
  return {
    type: AuthActionTypes.SET_TENANT,
    payload: data,
  };
};

export const setUserRole = (data) => {
  return {
    type: AuthActionTypes.SET_USER_ROLE,
    payload: data,
  };
};
